import React from 'react';
import UserCard from '../ProfileCard';
import LoadingGif from '../../../lib/images/loading.gif';
import * as RT from '../../../constants/Routing'
import { Link } from 'react-router-dom'
import defaultUserThumb from '../../../lib/images/user-thumb-default.png'
import moment from 'moment/min/moment-with-locales';
moment.locale('ja')
export default class Component extends React.Component {

  componentWillMount = () => {
    this.props.getMessageRoomList()
  }

  render = () => {
    const currentUser = this.props.App.currentUser
    const currentPath = this.props.router.location.pathname

    const loaded = this.props.UserMessages.chatRoomsLoaded
    let body
    if (loaded) {
      const chatRoomsProps = this.props.UserMessages.chatRooms
      if (chatRoomsProps && chatRoomsProps.length > 0) {
        body = chatRoomsProps.map(room => {
          const photo = room.photo || defaultUserThumb
          const time = moment(room.delivered_at).fromNow() || null
          return (
            <Link key={room.id} to={RT.MESSAGE_ROOM_PATH.replace(/:id/, room.id)} className='col-12 chatRoomWrap'>
              <div className='chatRoomItem'>
                <div className='userThumb' style={{ backgroundImage: `url(${photo})` }}></div>
                <div className='roomBody'>
                  <p className='user-name'>{room.name}</p>
                  <p className='latest-message'>{room.latest_message}</p>
                </div>
                <span className='messageDate'>{time}</span>
              </div>
            </Link>
          )
        })
      } else {
        body = (
          <div className='col-12'>
            メッセージはありません。
          </div>
        )
      }
      
    } else {
      body = (
        <div className='container'>
          <img src={LoadingGif} alt='' className='loading-img' />
        </div>
      )
    }

    return (
      <div className='container'>
        <UserCard user={currentUser} currentPath={currentPath} />
        <div className='row'>
          {body}
        </div>
      </div>
    )


  }
}


// WEBPACK FOOTER //
// ./src/components/User/Messages/Messages.jsx